<div class="grid grid-cols-3 gap-2">
    <div class="col-span-1">
        <h3 class="font-bold text-xl">Debit/Credit Card</h3>
    </div>
    <div class="col-span-2">
        <div class="w-full align-middle inline-flex justify-start gap-4">
            <img class="eft-banks" src="assets/icons/Icons/card-types/mastercard.svg" alt="mastercard">
            <img class="eft-banks" src="assets/icons/Icons/card-types/visa.svg" alt="visa">
            <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/card-types/amex.svg" alt="amex">
            <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/card-types/diners.svg" alt="diners">
        </div>
    </div>
</div>
<div class="w-full">
    <p class="my-6">Pay conveniently and securely using your debit or credit card&#33;</p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Enter your card details and click <b>Pay</b></p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Approve the 3DS request from your bank</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Transaction processed successfully  </p>
    </div>
    <p class="my-6">&#8727;We recommend saving your card for convenient future purchases&#33;</p>
</div>